import { fold as foldEither } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';

import { getCalculatorConfig } from '../../api/WCMApi';
import { CalculatorStepsStore } from '../Store/CalculatorStepsContext';
import { DatePresetsModel } from '../../model/DatePresetsModel';
import { fold } from 'fp-ts/lib/Option';
import { shareClasses } from '../../shared/constants';
import { analyticsErrorEvent } from "../../utils/Analytics";

function cleanParam(str: string | null): string {
    if (str) {
        return str.replace(/[^\w.]/g, '').trim();
    } else {
        return '';
    }
}

function cleanUserIdentifierParam(str: string | null): string {
    if (str) {
        return str.replace(/[^\w\d.]/g, '').trim();
    } else {
        return '';
    }
}

export const fetchResources = async (store: CalculatorStepsStore, setDatePresets: (d: DatePresetsModel) => void) => {

    const params = new URLSearchParams(window.location.search);
    const applicationName = cleanParam(params.get('applicationName'));
    const shareClass = cleanParam(params.get('shareClass'));

    const shareClassDisplay = shareClasses.get(shareClass)

    const userIdentifier = cleanUserIdentifierParam(params.get('userIdentifier'));
    const fetchableConfigPromise = getCalculatorConfig(setDatePresets, userIdentifier)
        .then(errorOrFetchable =>
            pipe(errorOrFetchable,
                foldEither((err) => {
                    console.log(`Resource API: Error fetching config: ${err}`);
                    analyticsErrorEvent("ToolError", `Resource API: Error fetching config: ${err.toString()}`);
                    return store.steps.config;
                },
                    (fetchableConfig) => {
                        const config = store.steps.config;

                        const configWithStrategies = pipe(fetchableConfig.strategies,
                            fold(() => config,
                                (strategies) => config.withAvailableInvestmentStrategies(strategies)));
                        const configWithDateRanges = pipe(fetchableConfig.dateRanges,
                            fold(() => configWithStrategies,
                                (dateRanges) => configWithStrategies.withAvailableDateRanges(dateRanges)));
                        const configWithCalculatorUrl = pipe(fetchableConfig.calculatorUrls,
                            fold(() => configWithDateRanges,
                                (calculatorUrls) => pipe(calculatorUrls.urlForConfig(applicationName, shareClass),
                                    fold(() => configWithDateRanges,
                                        (url) => configWithDateRanges.withCalculatorUrl(url)))));

                        const configWithExportUrl = pipe(fetchableConfig.calculatorUrls,
                            fold(() => configWithCalculatorUrl,
                                (calculatorUrls) => pipe(calculatorUrls.exportUrlForConfig(applicationName, shareClass),
                                    fold(() => configWithCalculatorUrl,
                                        (url) => configWithCalculatorUrl.withExportUrl(url)))));                            

                        const configWithShareClass = shareClassDisplay
                            ? configWithExportUrl.withShareClass(shareClassDisplay)
                            : configWithExportUrl;
                        const configWithProductCusip = pipe(fetchableConfig.calculatorUrls,
                            fold(() => configWithShareClass,
                                (calculatorUrls) => pipe(calculatorUrls.productCusipForConfig(shareClass),
                                    fold(() => configWithShareClass,
                                        (cusip) => configWithShareClass.withProductCusip(cusip)))));
                        const configWithUserIdentifier = pipe(fetchableConfig.userIdentifier,
                            fold(() => configWithProductCusip,
                                (userId) => configWithProductCusip.withUserIdentifier(userId)));
                        return configWithUserIdentifier;
                    })));

    const newConfig = await fetchableConfigPromise;
    store.setSteps(store.steps.withConfig(newConfig))

}
